import { Button, Card, Checkbox, Col, DatePicker, Divider, Form, Icon, Input, message, Row, Select, Spin, Switch } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/ComplaintSubList";
import DocumentList from "../../components/DocumentList";
import ImageList from './Photos';
import { PageSettingPopUp } from "../PageSetting/settingForm";
import AssetSearch from "../../components/AssetSearch";
import moment from 'moment';

class Create extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            documentData: [],
            documentImage: [],
            selectedAsset: null,
            assetData: [],
            autoJobcard: false,
            autoJobCardClose: false,
            closingDocuments: [],
            closingPhotos: []
        };
    }

    componentDidMount() {
        const { match, data, fetch, fetchAsset } = this.props;
        if (match.params && match.params.id) {
            fetch && fetch(match.params.id);
        }
        // console.log(match);

        if (match.params && match.params.asset) {
            fetchAsset && fetchAsset(match.params.asset);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && nextProps.data.photos && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
            const { photos } = nextProps.data;
            const photoData = photos.map(async p => {
                if (p.url) {
                    let file = await fetch(p.url).then(r => r.blob())
                        .then(blobFile => new File([blobFile], p.name, { type: p.mimeType }));
                    file['uid'] = p.url || new Date().getTime();
                    // console.log(file);
                    return file;
                }
            });
            Promise.all(photoData).then(photos => {
                if (photos && photos.length > 0) {
                    // console.log(photos);
                    this.props.form.setFieldsValue({ photos: photos });
                    this.setState({ documentImage: photos });
                }
            });

            const { autoJobcard, autoJobCardClose } = nextProps.data;
            this.setState({ autoJobcard, autoJobCardClose });
        }

        if (nextProps && nextProps.assetData && nextProps.assetData.length && JSON.stringify(nextProps.assetData) !== JSON.stringify(this.props.assetData)) {
            this.setState({
                assetData: nextProps.assetData.filter(a => a.assetModel)
            })
        }

        if (nextProps && nextProps.paramAssetData && JSON.stringify(nextProps.paramAssetData) !== JSON.stringify(this.props.paramAssetData)) {
            // console.log(nextProps.paramAssetData);

            this.setState({
                assetData: [nextProps.paramAssetData],
                selectedAsset: nextProps.paramAssetData._id
            })
            // this.props.form.setFieldsValue({ asset: nextProps.paramAssetData._id })
        }
    }

    componentDidUpdate(prevProps) {
        const { paramAssetData, data } = this.props;
        // console.log(paramAssetData);

        // Check if the prop has changed before updating the form
        if (paramAssetData && paramAssetData._id !== prevProps.paramAssetData._id) {
            // Safely update the form value after the component is updated
            this.props.form.setFieldsValue({
                asset: paramAssetData._id,
            });
        }

        if (data && data.asset && data.asset._id !== (prevProps.data && prevProps.data.asset && prevProps.data.asset._id)) {
            // Update the form value after the component has updated
            this.props.form.setFieldsValue({
                asset: data.asset._id,
            });
        }
    }



    getDocumentData = (data) => {
        this.setState({ documentData: data });
    };

    handleSubmit = (e) => {
        const { match, location, form } = this.props;
        // console.log(form);
        e.preventDefault();
        const backToModule = location.search.split("=")[1];
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            if (values && !values.service) {
                values.service = [];
            }

            const data = Object.assign({}, values);
            if (this.props.title === 'CREATE') {
                data.asset = this.state.selectedAsset;
                if (!data.asset) {
                    message.error(`Invalid Asset selected`)
                }
            }

            const { documentData } = this.state;
            // data.documents = documentData;
            if (documentData.length === 0) {
                data.documents = this.props && this.props.data && this.props.data.documents;
            } else {
                data.documents = documentData;
            }

            // data.autoJobcard = this.state.autoJobcard;
            // data.autoJobCardClose = this.state.autoJobCardClose;
            // data.closingRemarks = this.state.closingRemarks;
            // data.closingAmount = this.state.closingAmount;
            // data.closingPhotos = this.state.closingPhotos;
            const { closingDocuments } = this.state;
            if (closingDocuments.length === 0) {
                data.closingDocuments = this.props && this.props.data && this.props.data.quickCloseJobCard && this.props.data.quickCloseJobCard.documents;
            } else {
                data.closingDocuments = closingDocuments;
            }
            console.log('data for submit', data);

            if (match.params && match.params.id) {
                // console.log('data', data);
                if (backToModule) {
                    const urlForBackJobCardReport = `/job-card/report/${backToModule}`;
                    data.asset && this.props.onSubmit(data, match.params.id, urlForBackJobCardReport);
                } else {
                    data.asset && this.props.onSubmit(data, match.params.id);
                }
            } else {
                data.asset && this.props.onSubmit(data, e);
            }

        });
    };

    getImageData = (data) => {
        // console.log(data);
        this.props.form.setFieldsValue({ photos: data });
        this.setState({ documentImage: data });
    };

    assetSearch = (value) => {
        this.props.searchGlobalAssetData(value);
    };

    // Add new method to handle auto jobcard switch
    handleAutoJobcardChange = (checked) => {
        this.setState({
            autoJobcard: checked,
            // If auto jobcard is turned off, also turn off auto close
            autoJobCardClose: checked ? this.state.autoJobCardClose : false
        })
        // If turning off auto jobcard, also clear the auto close form fields
        if (!checked) {
            const { form } = this.props
            form.setFieldsValue({
                autoJobCardClose: false,
                closingRemarks: undefined,
                closingAmount: undefined,
                closingPhotos: undefined
            })
        }
    }

    // Add new method to handle auto close switch
    handleAutoCloseChange = (checked) => {
        this.setState({ autoJobCardClose: checked })
    }

    // Add new method for closing documents
    getClosingDocumentData = (data) => {
        this.setState({ closingDocuments: data });
    }

    // Add new method for closing photos
    getClosingImageData = (data) => {
        // console.log('data', data);
        this.setState({ closingPhotos: data });
        this.props.form.setFieldsValue({ closingPhotos: data });
    }

    render() {
        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const { data, loading, filters, title, resource, subDocumentFilters, form, authUser } = this.props;
        const { autoJobcard, autoJobCardClose } = this.state;

        // console.log('paramAssetData', this.props.paramAssetData);

        const manpowers = filters && filters['createdBy'] && filters['createdBy']['data'] && filters['createdBy']['data']['data']
        let defaultEmployee = null;
        if (manpowers && manpowers.length) {
            defaultEmployee = manpowers.filter(m => m.userAccount && m.userAccount._id && m.userAccount._id.toString() === authUser._id.toString())
        }


        return (
            <Spin spinning={loading}>
                {/*<PageSettingPopUp toggleVisible={this.props.togglePageSettingVisible} visible={this.props.pageSettingVisible}*/}
                {/*                  page={resource}/>*/}
                <Form onSubmit={this.handleSubmit} layout="vertical">
                    <Card className={`gx-card-metrics`} title={title}>
                        {
                            (title === 'EDIT') && <Form.Item key={'complaintNo'} label={'Complaint No'}>
                                {getFieldDecorator('complaintNo', {
                                    rules: [{ required: false, message: `Complaint No is required!` }],
                                    initialValue: this.props && this.props.complaintNo ? this.props.complaintNo : ((data && data.complaintNo) || ''),
                                })(<Input disabled />)
                                }
                            </Form.Item>
                        }
                        {
                            (title === 'EDIT') && <Form.Item key={'complaintType'} label={'Complaint Type'}>
                                {getFieldDecorator('complaintType', {
                                    rules: [{ required: false, message: `Complaint Type is required!` }],
                                    initialValue: this.props && this.props.complaintType ? this.props.complaintType : ((data && data.complaintType) || ''),
                                })(<Input disabled />)
                                }
                            </Form.Item>
                        }
                        {Object.keys(filters).map((item) => {

                            if (item === 'autoJobcard' || item === 'autoJobCardClose') {
                                return null;
                            }

                            const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
                            const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;

                            const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;

                            if (filters[item].type === 'Boolean') {
                                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                                    {getFieldDecorator(item, {
                                        rules: [{ required: filters[item].required, message: `${item} is required!` }],
                                        valuePropName: 'checked',
                                        initialValue: !!value,
                                    })(<Checkbox>&nbsp;</Checkbox>)}
                                </Form.Item>
                            }

                            // Document Upload Form
                            if (filters[item].type === 'Array' && filters[item].options.ref) {
                                return <DocumentList match={this.props.match} history={this.props.history}
                                    key={item} item={filters[item]} form={form} data={data[item]}
                                    subDocumentFilters={subDocumentFilters}
                                    getDocumentData={this.getDocumentData} hideEdit={true} hideRemove={true} />
                            }

                            if (filters[item].type === 'Array' && item === 'photos') {
                                return (
                                    <div>
                                        <Row type="flex" gutter={[8, 8]}>
                                            {(<Col span={12}>
                                                <Form.Item key={item} label={sanitizeFieldName(item)}>
                                                    {getFieldDecorator(item, {})(
                                                        <ImageList match={this.props.match} history={this.props.history}
                                                            documentData={this.state.documentImage}
                                                            key={item} item={filters[item]} form={form}
                                                            data={data && data.photos}
                                                            getDocumentData={this.getImageData.bind(this)} />)
                                                    }
                                                </Form.Item>
                                            </Col>)
                                            }
                                            {
                                                data && data.photos && (<Col span={12}>
                                                    <div>View Photos</div>
                                                    {
                                                        data.photos.map(item => {
                                                            return <a style={{ display: 'block' }} key={item.url}
                                                                href={`${item.url}`}
                                                                target='_blank'>{item.name}</a>
                                                        })
                                                    }
                                                </Col>)
                                            }
                                        </Row></div>
                                );
                            }

                            if (filters[item].type === 'Array' && filters[item].schema) {
                                return <SubList key={item} item={filters[item]} form={form} data={data && data[item]}
                                    title={title}
                                    resource={resource} />
                            } else {
                                if (filters[item].field !== 'complaintNo' && filters[item].field !== 'complaintType') {

                                    if (filters[item].field === 'asset') {
                                        return <Form.Item
                                            key={"asset"}
                                            label={"Enter Asset"}
                                            style={{ width: "100%" }}
                                        >
                                            {getFieldDecorator(`asset`, {
                                                rules: [{ required: true, message: `Asset is required!` }],
                                                initialValue: this.props.paramAssetData ? this.props.paramAssetData._id : data && data.asset && data.asset._id,
                                            })(
                                                <AssetSearch
                                                    disabled={title === 'EDIT'}
                                                    styleName="gx-lt-icon-search-bar-lg"
                                                    placeholder="Search Assets..."
                                                    onChange={this.assetSearch.bind(this)}
                                                    onSelect={(value) => value && this.setState({ selectedAsset: value })}
                                                    assetData={
                                                        this.state.assetData
                                                        // this.props.assetData && this.props.assetData.filter((ast) => ast.assetModel)
                                                    } // only assets with assetModel
                                                    authUser={this.props.authUser}
                                                    loading={this.props.assetSearchLoading}
                                                    defaultAsset={(this.props.paramAssetData && JSON.stringify(this.props.paramAssetData) !== '{}') ? this.props.paramAssetData : (data && data.asset)}
                                                />
                                            )}
                                        </Form.Item>
                                    }

                                    if (title === 'CREATE') {
                                        if (filters[item].field === 'complaintDate') {
                                            return <Form.Item key={'complaintDate'}
                                                label='Complaint Date'>
                                                {getFieldDecorator('complaintDate', {
                                                    rules: [{
                                                        required: true,
                                                        message: `Date is required!`
                                                    }],
                                                    initialValue: data && moment(data.complaintDate) || moment(),
                                                })(<DatePicker />)
                                                }
                                            </Form.Item>
                                        }

                                        if (filters[item].field === 'createdBy') {
                                            return <Form.Item key={'createdBy'} label={'Created By'}>
                                                {getFieldDecorator('createdBy', {
                                                    rules: [{ required: true, message: `Employee is required!` }],
                                                    initialValue: (defaultEmployee && defaultEmployee.length && defaultEmployee[0]) ? defaultEmployee[0]['_id'] : data && data.employee && data.employee._id,
                                                })(<Select
                                                    showSearch
                                                    style={{ width: '80%' }}
                                                    placeholder="Select Employee"
                                                    disabled={title === 'EDIT' || defaultEmployee && defaultEmployee.length && defaultEmployee[0]}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {filters['createdBy'] && filters['createdBy']['data'] && filters['createdBy']['data']['data'].map(item =>
                                                        <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                                                </Select>)}
                                            </Form.Item>
                                        }
                                        else if (filters[item].field !== 'location' && filters[item].field !== 'client') {
                                            return getFormFieldByType(filters, item, getFieldDecorator, data, {
                                                title,
                                                resource,
                                                setFieldsValue
                                            })
                                        }
                                    } else {
                                        return getFormFieldByType(filters, item, getFieldDecorator, data, {
                                            title,
                                            resource,
                                            setFieldsValue
                                        })
                                    }
                                }
                            }

                        }
                        )}

                    </Card>

                    <Card className={`gx-card-metrics`}>

                        <Form.Item label="Auto Jobcard">
                            {getFieldDecorator('autoJobcard', {
                                valuePropName: 'checked',
                                initialValue: data && data.autoJobcard || false
                            })(
                                <Switch onChange={this.handleAutoJobcardChange} disabled={title === 'EDIT'} />
                            )}
                        </Form.Item>

                        {autoJobcard && (
                            <Form.Item label="Target Date">
                                {getFieldDecorator('targetDate', {
                                    rules: [{ required: true, message: 'Target date is required!' }],
                                    initialValue: data && data.jobCard && data.jobCard.expectedDateOfCompletion && moment(data.jobCard.expectedDateOfCompletion) || moment()
                                })(
                                    <DatePicker
                                        disabled={title === 'EDIT'}
                                        disabledDate={(current) => {
                                            const complaintDate = form.getFieldValue('complaintDate')
                                            return current && current < moment(complaintDate).startOf('day')
                                        }}
                                    />
                                )}
                            </Form.Item>
                        )}

                    </Card>

                    <Card className={`gx-card-metrics`}>

                        {autoJobcard && (
                            <Form.Item label="Auto Close">
                                {getFieldDecorator('autoJobCardClose', {
                                    valuePropName: 'checked',
                                    initialValue: data && data.autoJobCardClose || false
                                })(
                                    <Switch onChange={this.handleAutoCloseChange} disabled={title === 'EDIT'} />
                                )}
                            </Form.Item>
                        )}

                        {autoJobCardClose && (
                            <>
                                <Form.Item label="Closing Date">
                                    {getFieldDecorator('closingDate', {
                                        rules: [{ required: true, message: 'Closing Date is required!' }],
                                        initialValue: data && data.quickCloseJobCard && data.quickCloseJobCard.closingDate || moment()
                                    })(
                                        <DatePicker format="DD-MM-YYYY" disabled={title === 'EDIT'}
                                            disabledDate={(current) => {
                                                const complaintDate = form.getFieldValue('complaintDate')
                                                return current && current <= moment(complaintDate).startOf('day')
                                            }}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label="Remarks">
                                    {getFieldDecorator('closingRemarks', {
                                        rules: [{ required: true, message: 'Remarks are required!' }],
                                        initialValue: data && data.quickCloseJobCard && data.quickCloseJobCard.remarks || ''
                                    })(
                                        <Input.TextArea rows={4} disabled={title === 'EDIT'} />
                                    )}
                                </Form.Item>

                                <Form.Item label="Amount">
                                    {getFieldDecorator('closingAmount', {
                                        rules: [{ required: true, message: 'Amount is required!' }],
                                        initialValue: data && data.quickCloseJobCard && data.quickCloseJobCard.amount || 0
                                    })(
                                        <Input type="number" disabled={title === 'EDIT'} />
                                    )}
                                </Form.Item>

                                <DocumentList
                                    match={this.props.match}
                                    history={this.props.history}
                                    item={filters['documents']}
                                    form={form}
                                    data={data && data.quickCloseJobCard && data.quickCloseJobCard.documents}
                                    subDocumentFilters={subDocumentFilters}
                                    getDocumentData={this.getClosingDocumentData}
                                    hideEdit={true}
                                    hideRemove={true}
                                    disabled={title === 'EDIT'}
                                />

                                <div>
                                    <Row type="flex" gutter={[8, 8]}>
                                        {(<Col span={12}>
                                            <Form.Item label="Closing Photos">
                                                {getFieldDecorator('closingPhotos', {})(
                                                    <ImageList
                                                        match={this.props.match}
                                                        history={this.props.history}
                                                        documentData={this.state.closingPhotos}
                                                        item={filters['closingPhotos']}
                                                        form={form}
                                                        getDocumentData={this.getClosingImageData.bind(this)}
                                                        disabled={title === 'EDIT'}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>)
                                        }
                                        {
                                            data && data.quickCloseJobCard && data.quickCloseJobCard.photos && (<Col span={12}>
                                                <div>View Photos</div>
                                                {
                                                    data.quickCloseJobCard.photos.map(item => {
                                                        return <a style={{ display: 'block' }} key={item.url}
                                                            href={`${item.url}`}
                                                            target='_blank'>{item.name}</a>
                                                    })
                                                }
                                            </Col>)
                                        }
                                    </Row></div>


                            </>
                        )}

                        <Form.Item>
                            <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                            </Button>
                            {this.props.title === 'EDIT' && (
                                <small>
                                    All photos need to be reuploaded.
                                </small>
                            )}
                        </Form.Item>

                    </Card>
                </Form>
            </Spin>
        );
    }
}

const CreateForm = Form.create({
    name: 'global_state',
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    },
})(Create);

export default CreateForm;
